import { types } from 'mobx-state-tree';
import { GeoCoordinate, OptOutFeature } from '../config';

export const DistanceSystems = types.enumeration(['metric', 'imperial']);

export const DistanceSystem = types.optional(DistanceSystems, 'metric');

export const DistanceTypes = {
  metric: 'km',
  imperial: 'm',
};

export const Config = types.model({
  showZoomControl: OptOutFeature,
  showCompassControl: OptOutFeature,
  showPositionControl: OptOutFeature,
  preferedDistanceSystem: DistanceSystem,
});

export const UserStore = types
  .model({
    config: types.optional(Config, {}),
    position: types.optional(types.maybeNull(GeoCoordinate), null),
  })
  .actions((self) => ({
    setPosition: (pos) => (self.position = pos),
  }));
